import type { CartItemInput, ProductInterface } from '@pylot-data/pylotschema'

export type PendingMixAddToCart = {
    cartItems: CartItemInput[]
    products?: ProductInterface[]
    excludeItems?: string[]
    shouldDoOptimisticUpdate?: boolean
    displayLoadingIndicator?: boolean
}

type MixAlertListener = (isOpen: boolean) => void

const listeners = new Set<MixAlertListener>()
let pendingMixAdd: PendingMixAddToCart | null = null

const notify = (): void => {
    const isOpen = pendingMixAdd !== null
    listeners.forEach((listener) => listener(isOpen))
}

export const subscribeGiftCardMixAlert = (
    listener: MixAlertListener
): (() => void) => {
    listeners.add(listener)
    listener(pendingMixAdd !== null)
    return () => {
        listeners.delete(listener)
    }
}

export const openGiftCardMixAlert = (pending: PendingMixAddToCart): void => {
    pendingMixAdd = pending
    notify()
}

export const closeGiftCardMixAlert = (): void => {
    pendingMixAdd = null
    notify()
}

/** Cierra el modal en UI sin perder el add pendiente (p. ej. login). */
export const hideGiftCardMixAlert = (): void => {
    listeners.forEach((listener) => listener(false))
}

export const takePendingGiftCardMixAdd = (): PendingMixAddToCart | null => {
    const pending = pendingMixAdd
    pendingMixAdd = null
    notify()
    return pending
}
